import React, { useState } from 'react';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { GoogleLogin } from '@react-oauth/google';
import { setLoginSession } from '../utils/common';
import { axiosPostCall } from '../services/apisCall';
import { ToastContainer } from 'react-toastify';
import { renderErrorMessage, renderSuccessMessage } from '../lib/toastMessage';
import LoadingSpinner from '../components/LoadingSpinner';
import { removeItem } from '../lib/cookies';
import Logger from '../lib/Logger';
import { jwtDecode } from 'jwt-decode';

//@mui
import { Box, Modal, Button, Typography, Divider } from '@mui/material';
import { useSocket } from 'src/context/SocketContext';
import { ACCESS_KEY } from '../config/commonConfig';

const logger = new Logger("Login");

import { configFile } from '../config';
const { GOOGLE_AUTH_CLIENT_ID } = configFile;
import { LOGIN_PAGE_RELOAD_TIME_ON_ERROR } from '../config/commonConfig';

const Login = () => {
  const socket = useSocket()
  const [loading, setLoading] = useState(false)
  const [open, setOpen] = useState(true);
  const handleGoogleLogin = async (googleToken) => {
    setLoading(true)
    try {
      const { exp, sessionToken, token, message } = await axiosPostCall("login", { token: googleToken });

      if (!exp || !sessionToken || !token) {
        setLoading(false)
        renderErrorMessage("internal server error")
        return window.location.href = "/";

      }
      setLoginSession(exp, sessionToken);
      // localStorage.setItem("token",token);
      // return window.location.href = "/home";
      const decodedToken = jwtDecode(token);

        const userAccess = decodedToken.access || {};
        // Build key → access entry map from the JWT (mirrors checkButtonAccess).
        const keyToAccess = Object.values(userAccess).reduce((acc, entry) => {
          if (entry.key) acc[entry.key] = entry;
          return acc;
        }, {});
        const routesMap = [
          { path: "/home", key: "homePageList" },
          { path: "/kyc", key: "kycPageList" },
          { path: "/leads", key: "leads" },
          { path: "/users", key: "adminPageList" },
          { path: "/plans", key: "createConsoleuser" },
          { path: "/billing", key: "billingPageList" },
          { path: "/updatepermissions", key: "smsGatewayPageList" },
          { path: "/console_users", key: "consolePageList" },
          { path: "/advertisement", key: "advertisementPageList" },
          { path: "/branding", key: "advertisementPageList" },
          { path: "/announcementList", key: "viewAnnouncementIvrList" },
          { path: "/meet", key: "meetPageList" },
          { path: "/webinar", key: "webinarPageList" },
          { path: "/sms", key: "smsGatewayPageList" },
          { path: "/profile", key: "adminPageList" },
          { path: "/add_new_user", key: "addNewUser" },
          { path: "/leads_analysis", key: "webinarPageList" },
          { path: "/createUser", key: "createConsoleuser" }
        ];

        const firstAccessibleRoute = routesMap.find(route => keyToAccess[route.key]?.id);
        if(firstAccessibleRoute){
          localStorage.setItem("token", token);
          renderSuccessMessage(message);
          return window.location.href = firstAccessibleRoute.path;
        }else{
          return renderErrorMessage("You don't have sufficient permission, contact to admin!");
        }
    } catch (error) {
      logger.error("home.jsx , handleGoogleLogin,login", error);
      renderErrorMessage(error.message);
      setTimeout(() => {
        setLoading(false)
        return window.location.href = "/";
      }, LOGIN_PAGE_RELOAD_TIME_ON_ERROR);
    }
  }

  useState(() => {
    removeItem("g_state")
  }, [])

  const handlePasswordLoginClick = () => {
    window.location.href = `/?key=${ACCESS_KEY}`;
  };

  return (
    <>
    {/* <ToastContainer /> */}
    <Box sx={{ outline: 'none' }}>
      <Box sx={{
        height: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        gap: 3

      }}>
        <Typography variant="h4" sx={{ mb: 2 }}>
          Admin Login
        </Typography>

        <GoogleOAuthProvider clientId={GOOGLE_AUTH_CLIENT_ID}>
          <GoogleLogin
            onSuccess={credentialResponse => {
              const token = credentialResponse.credential
              handleGoogleLogin(token)
            }}
            onError={() => {
              console.log('Login Failed');
            }}
            useOneTap
            cancel_on_tap_outside
          />
        </GoogleOAuthProvider>

        <Divider sx={{ width: '300px', my: 2 }}>
          <Typography variant="body2" color="text.secondary">
            OR
          </Typography>
        </Divider>

        <Button
          variant="outlined"
          onClick={handlePasswordLoginClick}
          sx={{
            textTransform: 'none',
            minWidth: '200px',
            py: 1
          }}
        >
          Login with Email / Password
        </Button>
      </Box>
    </Box>
    </>

  )
}

export default Login;
